import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';

const { Option } = Select;

const DivisionForm = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [divisions, setDivisions] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/master/divisions`;
    axios.get(url).then(resp => {
      setDivisions(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <>
      <Select
        defaultValue={formik.values.division}
        onChange={(value) => formik.setFieldValue("division", value)}
        placeholder="Pilih divisi operasi"
        loading={loading}
      >
        {divisions.map((division, key) => {
          return <Option value={division.id} key={`division-${key}`}>{division.name}</Option>
        })}
      </Select>
      <ErrorMessage component="div" name="division" className="gx-mt-2 gx-text-red" />
    </>
  );
}

export default DivisionForm;